@if (layout.sidebarOpen()) {
  <div class="sidebar-backdrop" (click)="layout.closeSidebar()"></div>
}
<nav class="sidebar" [class.open]="layout.sidebarOpen()" [class.collapsed]="layout.sidebarCollapsed()">
  <div class="sidebar-header">
    <img class="app-logo" src="/branding/app-logo.png" [alt]="'shared.logoAlt' | translate" />
    <span class="app-name">{{ 'shared.logoAlt' | translate }}</span>
  </div>

  @for (item of navItems(); track item.path) {
    @if (item.children) {
      <div class="nav-group">
        <button
          type="button"
          class="nav-item nav-group-toggle"
          [class.section-active]="isSectionActive(item)"
          [attr.aria-expanded]="isGroupExpanded(item)"
          (click)="toggleGroup(item)"
        >
          <app-icon [name]="item.icon" [size]="18" />
          <span class="label">{{ item.labelKey | translate }}</span>
          <app-icon
            class="chevron flip-rtl"
            [name]="isGroupExpanded(item) ? 'chevron-down' : 'chevron-right'"
            [size]="14"
          />
        </button>

        @if (isGroupExpanded(item)) {
          <div class="nav-children">
            @for (child of item.children; track child.path) {
              <a
                [routerLink]="child.path"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                class="nav-item nav-child"
                (click)="layout.closeSidebar()"
              >
                <span class="label">{{ child.labelKey | translate }}</span>
              </a>
            }
          </div>
        }
      </div>
    } @else {
      <a [routerLink]="item.path" routerLinkActive="active" class="nav-item" (click)="layout.closeSidebar()">
        <app-icon [name]="item.icon" [size]="18" />
        <span class="label">{{ item.labelKey | translate }}</span>
      </a>
    }
  }

  <button type="button" class="collapse-toggle" (click)="layout.toggleSidebarCollapsed()">
    <app-icon [name]="layout.sidebarCollapsed() ? 'chevron-right' : 'chevron-left'" [size]="18" class="flip-rtl" />
    <span class="label">{{ (layout.sidebarCollapsed() ? 'shared.nav.expandMenu' : 'shared.nav.collapseMenu') | translate }}</span>
  </button>
</nav>
